// extracted by mini-css-extract-plugin
export default {"deleteBtn":"liked_deleteBtn__zDyWI"};